import { useEffect, useState } from 'react';

import type { SessionNoteSettings } from '@/entities/session-note';

import type { EditableNoteSettingKey } from './edit-session-note-settings.types';

export const useSettingsState = (
    defaultSettings: SessionNoteSettings,
    onChange: (settings: SessionNoteSettings) => void,
) => {
    const [settings, setSettings] = useState<SessionNoteSettings>(defaultSettings);

    useEffect(() => {
        setSettings(defaultSettings);
    }, [defaultSettings]);

    const update = <K extends EditableNoteSettingKey>(key: K, value: SessionNoteSettings[K]) => {
        setSettings((prev) => ({ ...prev, [key]: value }));
    };

    const save = () => {
        onChange(settings);
    };

    const reset = () => {
        setSettings(defaultSettings);
    };

    return { settings, update, save, reset };
};
